import React from 'react';
import { AutoComplete, Input, Select } from 'antd';
import { Search, Building2 } from 'lucide-react';
import { User } from '../../../data';
import { FilterBar, FilterField } from '../../common';
import { usePromoterSearch } from './promoterTable.controller';
import { t } from '../../../company/labels';

function TableActions({ promoters, setRows, clientOptions = [], selectedClientId = null, onClientChange }) {
    const isClientUser = User.getInstance()?.userType === 'client';
    const { suggestions, searchValue, setSearchValue, onSearch } = usePromoterSearch(promoters, setRows);

    return (
        <FilterBar className="!mb-0">
            <FilterField label={t('promotor')} width={288}>
                <AutoComplete
                    value={searchValue}
                    options={suggestions.map((suggestion) => ({ value: suggestion }))}
                    onSearch={onSearch}
                    onSelect={onSearch}
                    onChange={(value) => setSearchValue(value)}
                    placeholder={`Buscar ${t('promotorLower')}...`}
                    className="w-full">
                    <Input prefix={<Search className="text-surface-400" />} allowClear />
                </AutoComplete>
            </FilterField>

            {/* Filter by client — admin/gerente only (client users are already scoped) */}
            {!isClientUser && (
                <FilterField label="Cliente" width={256}>
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        placeholder="Filtrar por cliente"
                        className="w-full"
                        value={selectedClientId || undefined}
                        options={clientOptions}
                        onChange={(value) => onClientChange?.(value || null)}
                        suffixIcon={<Building2 className="text-surface-400" />}
                    />
                </FilterField>
            )}
        </FilterBar>
    );
}

export default TableActions;
